<template>
  <zg-module
    v-bind="moduleProps"
    class="zg-text-section"
    :full-width="fullWidth || splitContent"
  >
    <slot
      slot="sub-title"
      name="sub-title"
    />

    <div
      :class="['zg-text-section__container', {
        'zg-text-section__container--with-aside': hasAside
      }]"
    >
      <div
        :class="['zg-text-section__body', {
          'zg-text-section__body--split': splitContent,
          'zg-text-section__body--full-width': fullWidth || splitContent
        }]"
      >
        <slot
          class="slot"
          name="body"
        />
      </div>

      <aside v-if="hasAside">
        <slot name="aside" />
      </aside>
    </div>
  </zg-module>
</template>

<script>
  import module from '../../../mixins/module.js'
  import ZgModule from '../ZgModule/ZgModule.vue'

  export default {
    name: 'ZgTextSection',
    components: {
      ZgModule
    },
    mixins: [module],
    props: {
      splitContent: {
        type: Boolean,
        default: false
      },
      fullWidth: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      hasAside () {
        return Boolean(this.$slots.aside)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-text-section {
    &__container {
      display: flex;
      flex-direction: column-reverse;
      gap: rhythm(medium);

      @include mq(medium) {
        display: grid;
        flex-direction: unset;
        gap: rhythm(base);

        &--with-aside {
          grid-template-columns: 2fr minmax(rem(410), 1fr);
          align-items: start;
        }
      }
    }

    &__body {
      max-width: rem(720);
      overflow-wrap: anywhere;

      &--split {
        @include mq(medium) {
          column-count: 2;
          column-gap: rhythm();
        }
      }

      &--full-width {
        max-width: unset;
      }

      ::v-deep h1:not(:first-child),
      ::v-deep h2:not(:first-child),
      ::v-deep h3:not(:first-child),
      ::v-deep h4:not(:first-child),
      ::v-deep h5:not(:first-child),
      ::v-deep h6:not(:first-child),
      ::v-deep .zg-faq:not(:first-child) {
        margin-top: rhythm(double);
      }

      ::v-deep h1,
      ::v-deep h2 {
        @include type-title-m;

        @include mq(medium) {
          @include type-title-l;
        }
      }

      div {
        break-inside: avoid;
      }
    }

    ::v-deep img {
      width: 100%;
      background: color(gray-200);
      border-radius: rhythm(half);
      margin-top: rhythm(medium);
    }

    ::v-deep button {
      margin: rhythm(base) 0;
    }
  }

  ::v-deep table {
    overflow-x: auto;
    border-collapse: collapse;
    margin-bottom: rem(24px);

    thead {
      font-weight: font-weight(bold);
    }

    th,
    td {
      text-align: left;
      vertical-align: baseline;
      border: 1px solid color(gray-500);
      padding: rhythm(xsmall);
    }

    tr:hover {
      background: color(beige);
    }
  }

  aside {
    @include mq(medium) {
      position: sticky;
      top: rhythm();
      align-self: start;
    }
  }
</style>
